"use client";

import { NavLink } from "@/data/navLinks";
import { cn } from "@/lib/utils";
import { usePathname } from "next/navigation";
import React from "react";

type ClientLayoutProps = {
  children: React.ReactNode;
  className?: string;
  hideGlobalNav?: boolean;
};

const ClientLayout = ({ children }: ClientLayoutProps) => {
  const pathname = usePathname();
  const isFormPage =
    pathname.includes(NavLink.BookACall) || pathname.includes("/lp/");
  const isAtlasPage = pathname.startsWith("/atlas");

  return (
    <div className={cn({ "bg-grey-200/60": isFormPage })}>
      <div
        className={cn(
          isFormPage &&
          "bg-[linear-gradient(110deg,rgba(215,14,134,0.05)_20%,rgba(36,56,139,0.05)_100%)]",
          isAtlasPage &&
          "bg-[linear-gradient(0deg,#FFFFFF,#FFFFFF),linear-gradient(141.84deg,rgba(215,14,134,0.06)_3.19%,rgba(36,56,139,0.06)_91.11%)] dark:bg-none",
          !isFormPage && !isAtlasPage && "bg-grey-100"
        )}
      >
        {children}
      </div>
    </div>
  );
};

export default ClientLayout;
